module.exports = __webpack_public_path__ + "static/media/flags_GBR.247117e4.svg";